import { formatIsoDate, parseIsoDate, subtractDay } from '@src/shared/lib';
import type { Absence, TimelineSlot } from '../types';

/** FullCalendar selection dates: inclusive draft days become an exclusive end. */
export function toCalendarSelection(
  activeSelection: TimelineSlot | null,
  absences: Absence[],
  isDayView: boolean,
) {
  if (
    !activeSelection?.start ||
    !activeSelection.end ||
    !activeSelection.resourceId
  ) {
    return null;
  }
  const endDate = parseIsoDate(activeSelection.end);
  if (!parseIsoDate(activeSelection.start) || !endDate) {
    return null;
  }
  if (isDayView) {
    let { startTime, endTime } = activeSelection;

    if (startTime == null && endTime == null) {
      // Check edited absence first (excluded from selectedIds)
      const editedId =
        activeSelection.editedAbsenceId ??
        activeSelection.editedAbsenceIds?.[0];
      const editedAbsence = editedId
        ? absences.find((a) => a.id === editedId)
        : null;

      if (
        editedAbsence &&
        !editedAbsence.allDay &&
        editedAbsence.startTime != null
      ) {
        startTime = editedAbsence.startTime;
        endTime = editedAbsence.endTime;
      } else if (activeSelection.selectedIds.length > 0) {
        const firstHourly = activeSelection.selectedIds
          .map((id) => absences.find((a) => a.id === id))
          .filter((a): a is Absence => !!a && !a.allDay)
          .sort((a, b) =>
            (a.startTime ?? '').localeCompare(b.startTime ?? ''),
          )[0];

        if (firstHourly) {
          startTime = firstHourly.startTime;
          endTime = firstHourly.endTime;
        }
      }
    }

    const start = formatIsoDate(activeSelection.start, startTime ?? '00:00');
    const end = formatIsoDate(activeSelection.end, endTime ?? '23:59');

    return {
      start,
      end,
      resourceId: activeSelection.resourceId,
      allDay: false,
    };
  } else {
    const exclusiveEnd = formatIsoDate(subtractDay(endDate, -1));

    return {
      start: activeSelection.start,
      end: exclusiveEnd,
      resourceId: activeSelection.resourceId,
      allDay: true,
    };
  }
}
